import React, { PureComponent } from 'react'
import { Panel, Button } from 'react-bootstrap'
import { Field } from 'redux-form'
import { permissions } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects } from '../../../util/utils'
import InputCheckboxSlider from '../../../components/commons/form/InputCheckboxSlider'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import InputSelect from '../../../components/commons/form/InputSelect'
import ComponentTitle from '../../../containers/dossiers/commons/ComponentTitlePage'

export default class Crane extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      fieldsConfiguration: {
        needCrane: null,
        destinationCraneId: null,
        confirmationDate: null,
        confirmationDoneButton: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  toggleComponent () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ open: !this.state.open })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.dossierId) {
      if (!compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
        this.initializePermisions(this.props)
      }
      if (!prevProps.open && this.props.open) {
        this.setState({ open: true })
      }
    }
    return prevProps
  }

  componentDidUpdate () {
    // don't remove use for getsnapshot
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  updateNeedCrane (value) {
    if (value) {
      this.props.actions.activateDossierCrane(this.props.dossierId, this.props.pristine)
    } else {
      this.props.actions.deactivateDossierCrane(this.props.dossierId, this.props.pristine)
    }
  }

  render () {
    const {
      t, readOnlyFields, dossierId, dossier: { crane }, combos: { destinationCraneCombo },
      actions: { dossierCraneConfirmDate }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.CRANE.'

    return (
      <div className="dossier-Component">
        <div className="header-panel" onClick={() => this.toggleComponent()}>
          <ComponentTitle
            componentCode="CRANE"
            componentOpen={this.state.open}
            // extraInfo={'info extra'}
            // extraData={<a className="_Btn accept">texto</a>}
          />
        </div>
        <Panel expanded={this.state.open} onToggle={() => { }}>
          <Panel.Collapse>
            {!readOnlyFields && this.state.fieldsConfiguration.confirmationDoneButton && this.state.fieldsConfiguration.confirmationDoneButton.permission === permissions.editable && (
              <div className="flexInLine al-R">
                <Button className='_Btn new' onClick={() => dossierCraneConfirmDate(dossierId)} >
                  {t(`${tKey}PERFORM`)}
                </Button>
              </div>
            )}
            {this.state.fieldsConfiguration.needCrane && this.state.fieldsConfiguration.needCrane.permission !== permissions.hidden && (
              <div className='fieldsContainer'>
                <Field
                  component={InputCheckboxSlider}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="needCrane"
                  name="crane.needCrane"
                  placeholder={t(`${tKey}NEED_CRANE`)}
                  onChange={this.updateNeedCrane.bind(this)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.needCrane.permission !== permissions.editable}
                />
              </div>
            )}
            <div className='fieldsContainer'>
              {this.state.fieldsConfiguration.destinationCraneId && this.state.fieldsConfiguration.destinationCraneId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="destinationCraneId"
                  name="crane.destinationCraneId"
                  controlLabel={t(`${tKey}SEND_TO`)}
                  placeholder={t(`${tKey}SEND_TO`)}
                  options={destinationCraneCombo}
                  valueKey="id"
                  labelKey="value"
                  disabled={readOnlyFields || !crane.needCrane || this.state.fieldsConfiguration.destinationCraneId.permission !== permissions.editable} />
              )}
              {this.state.fieldsConfiguration.confirmationDate && this.state.fieldsConfiguration.confirmationDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="confirmationDate"
                  name="crane.confirmationDate"
                  colSm={3}
                  controlLabel={t(`${tKey}CONFIRM_DATE`)}
                  placeholder={t(`${tKey}CONFIRM_DATE`)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.confirmationDate.permission !== permissions.editable}
                  customClass={readOnlyFields || this.state.fieldsConfiguration.confirmationDate.permission !== permissions.editable ? 'disabled' : ''}
                />
              )}
            </div>
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}
